import React, { useContext } from "react";

import classnames from "classnames";

import { SearchContext, MAX_BEDROOMS } from "components/store/source";
import { Text } from "components/ui/source";
import Counter from "components/ui/source/atoms/Counter";

import styles from "./AmenityCounter.module.scss";

type AmenityCounterProps = {
  amenity?: "bedroom_count" | "bed_count" | "bathroom_count";
  incrementCount?(): void;
  decrementCount?(): void;
  mobile?: boolean;
};

export function AmenityCounter({
  incrementCount = () => {},
  decrementCount = () => {},
  amenity = "bedroom_count",
  mobile = false,
}: AmenityCounterProps) {
  const { criteria } = useContext(SearchContext);
  const { amenities } = criteria;
  const amenityCount = amenities[amenity];
  const size = mobile ? "md" : "sm";

  return (
    <div className={classnames(styles.counter, styles[size])}>
      <div className={styles.label}>
        <Text
          translateKey={`filters.amenitiesFilters.${amenity}.label`}
          types={["caption1", "inline"]}
        />
      </div>
      <Counter
        count={amenityCount}
        onDecrement={decrementCount}
        onIncrement={incrementCount}
        max={MAX_BEDROOMS}
        size={size}
      />
    </div>
  );
}

AmenityCounter.displayName = "AmenityCounter";
